<template>
    <section>
        <bread-crumb></bread-crumb>
        <div class="charge-wrap">
            <div class="charge-title">
                <h1>充值优惠</h1>
                <p>
                    账户余额：
                    <span>¥{{ walletInfo.available_balance }}</span>
                </p>
            </div>

            <ul v-show="rechargeList && rechargeList.length">
                <li v-for="(item, index) in rechargeList" :key="index" @click="onItemClick(index, item)">
                    <div class="click-tap" :class="flag == index ? 'active' : ''"></div>
                    <div class="charge-detail">
                        <div class="money-wrap charge-num">
                            <p>{{ item.recharge_money }}</p>
                            <p class="tips">充值</p>
                        </div>

                        <div class="money-wrap"><p class="symbol">+</p></div>

                        <div class="money-wrap">
                            <p class="money">{{ item.recharge_amount }}</p>
                            <p class="tips">赠送</p>
                        </div>

                        <div class="money-wrap"><p class="symbol">=</p></div>

                        <div class="money-wrap">
                            <p class="money">{{ (Number(item.recharge_money) + Number(item.recharge_amount)).toFixed(2) }}</p>
                            <p class="tips">到账</p>
                        </div>
                    </div>
                </li>
            </ul>

            <p class="pay-money">
                应付金额：
                <span>¥{{ chargeMoney }}</span>
            </p>
            <div class="charge-money" @click="payMent">立即充值</div>
            <div class="tips-wrap">
                <h2>充值说明：</h2>
                <p>1、充值金额获得相应的金额赠送，如：充值1000赠送100则到账1100。</p>
                <p>2、充值金额已涵盖赠送，只支持用户系统内下单、追加使用，不支持退还。</p>
            </div>

            <pay-modal @close="close" @chargeBack="chargeBack" v-if="isPayModal" :charge-money="chargeMoney" :uuid="uuid" type="charge" ref="payModal"></pay-modal>
        </div>
    </section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import payModal from '@/components/payModal.vue';
import { mapState, mapActions } from 'vuex';
import { getRechargeClassList } from '@/api/recharge.js';
export default {
    data() {
        return {
            isPayModal: false,
            flag: 0,
            rechargeList: [],
            uuid: '',
            chargeMoney: '',
            isSuccess: false,
            backUrl: this.$route.query.url
        };
    },

    created() {
        this.getMyWallet();
        this.getRechargeClassInfo();
    },

    computed: {
        ...mapState(['walletInfo'])
    },

    methods: {
        ...mapActions(['getMyWallet']),
        async getRechargeClassInfo() {
            const { data, status } = await getRechargeClassList();
            if (status !== 200) return;
            this.rechargeList = data.char;
            this.uuid = this.rechargeList[0].uuid; // 默认选第一个档次
            this.chargeMoney = this.rechargeList[0].recharge_money;
        },

        onItemClick(index, item) {
            this.flag = index;
            this.uuid = item.uuid;
            this.chargeMoney = item.recharge_money;
        },

        // 立即充值
        payMent() {
            this.isPayModal = true;
            this.$nextTick(() => {
                this.$refs.payModal.payRecharge(1);
            });
        },

        close() {
            this.isPayModal = false;
        },

        chargeBack() {
            if (this.backUrl) {
                location.href = decodeURIComponent(this.backUrl);
            } else {
                this.getMyWallet();
            }
        }
    },

    components: {
        BreadCrumb,
        payModal
    }
};
</script>

<style lang="scss" scoped>
.charge-wrap {
    .charge-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 28px;
        h1 {
            @include font-style;
            font-size: 20px;
            color: #000000;
        }
        p {
            @include font-style;
            font-size: 20px;
            color: #333333;
            span {
                color: #ff8d1c;
            }
        }
    }
    li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 30px;
        .click-tap {
            width: 30px;
            height: 30px;
            margin-right: 30px;
            background: url(../../assets/img/un-select.png) no-repeat center;
            background-size: 100%;
        }
        .active {
            background: url(../../assets/img/select.png) no-repeat center;
            background-size: 100%;
        }
        .charge-detail {
            flex: 1;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding: 25px 0;
            padding-left: 110px;
            background: #ffffff;
            box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.16);
            border-radius: 5px;
            .money-wrap {
                @include font-style;
                font-size: 20px;
                color: #333333;
                p {
                    margin-bottom: 20px;
                    text-align: center;
                }
                .money {
                    color: #ff8d1c;
                }
                .symbol {
                    padding: 0 70px;
                }
                .tips {
                    font-size: 18px;
                    color: #999999;
                    margin-bottom: 0;
                }
            }
            .charge-num{
                min-width: 110px;
            }
        }
    }
    li:last-child {
        margin-bottom: 0;
    }
    .pay-money {
        margin: 60px 0 30px 0;
        text-align: center;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #666666;
        span {
            color: #ff8d1c;
        }
    }
    .charge-money {
        cursor: pointer;
        width: 380px;
        height: 80px;
        margin: 0 auto 60px auto;
        line-height: 80px;
        text-align: center;
        background: #ff8d1c;
        box-shadow: 0px 8px 10px 0px rgba(31, 56, 117, 0.08);
        border-radius: 5px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }
    .tips-wrap {
        h2 {
            font-size: 20px;
            @include font-style;
            color: #333333;
            margin-bottom: 30px;
        }
        p {
            line-height: 35px;
            font-size: 18px;
            @include font-style;
            color: #666666;
        }
    }
}
</style>
